module.exports = __webpack_public_path__ + "img/eyes-03.eb038746.svg";